import React from "react";
import Modal from "react-bootstrap/Modal";
import { Input, Button, Card, Form } from "antd";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";
import {
  apiRoutes,
  get_api_generate_otp_call,
  post_api_validate_otp_call,
} from "../DataProvider";
import { localStorageVariableName, settings } from "swfrontend/AppConfigs";
import "../LoginPage.css";

/**
 * @param: username -> string
 * @param: mail -> string
 * @param: duration -> number
 */
export default class OTPVerification extends React.Component {
  state = {
    time: {},
    seconds: this.props.duration ? this.props.duration : 180,
    otpInput: "",
    mail: this.props.mail ? this.props.mail : "",
    showProgressbar: false,
  };
  timer = 0;

  componentDidMount() {
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
    this.startTimer();
  }

  secondsToTime = (secs) => {
    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      m: minutes,
      s: seconds,
    };
    return obj;
  };

  startTimer = () => {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  };

  countDown = () => {
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });
    if (seconds === 0) {
      clearInterval(this.timer);
    }
  };

  requestOTP = () => {
    this.setState({ showProgressbar: true, otpInput: "" }, () => {
      get_api_generate_otp_call(apiRoutes.requestOTP, this.props.username)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              this.timer = 0;
              let timeLeftVar = this.secondsToTime(res.duration);
              this.setState(
                { mail: res.mail, seconds: res.duration, time: timeLeftVar },
                () => {
                  this.startTimer();
                  openNotification("info", res["message"]);
                }
              );
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).forEach((each) => {
                openNotification("error", res[each]);
              });
            });
          }
        })
        .finally(() => {
          this.setState({ showProgressbar: false });
        });
    });
  };

  validateOTP = () => {
    if (this.state.otpInput.length !== 6) {
      openNotification("error", "Please input correct OTP");
      return;
    }

    let values = { username: this.props.username, otp: this.state.otpInput };

    this.setState({ showProgressbar: true }, () => {
      post_api_validate_otp_call(apiRoutes.validateOTP, values)
        .then((res) => {
          if (res.ok) {
            return res.json().then((loginAuth) => {
              openNotification("success", "OTP Verified, Logging in");
              localStorage.setItem(
                localStorageVariableName.authToken,
                JSON.stringify("Token " + loginAuth["Your Token"])
              );
              localStorage.setItem(localStorageVariableName.isLoggedIn, true);
              localStorage.setItem(
                localStorageVariableName.userName,
                this.props.username
              );
              let path = process.env.REACT_APP_PROJECT_ROUTE;
              path = path == "/null" ? "" : path;
              window.location.reload()
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).forEach((each) => {
                openNotification("error", res[each]);
              });
            });
          }
        })
        .finally(() => {
          this.setState({ showProgressbar: false });
        });
    });
  };

  render() {
    return (
      <div>
        <Modal show={this.state.showProgressbar} centered>
          <Modal.Body>
            <FormLoader loading="true" />
          </Modal.Body>
        </Modal>
        <div>
          <br />
          <br />
          <p style={{ fontWeight: "bold" }}>
            We have sent you an OTP on {this.state.mail}
          </p>
          <Form.Item>
            <Input
              style={{ textAlign: "center" }}
              placeholder="Input one time password"
              maxLength={6}
              value={this.state.otpInput}
              onChange={(e) => {
                this.setState({ otpInput: e.target.value });
              }}
              disabled={this.state.seconds === 0}
            />
            <p style={{ textAlign: "right" }}>
              Time Remaining: {this.state.time.m < 10 ? "0" : ""}
              {this.state.time.m}:{this.state.time.s < 10 ? "0" : ""}
              {this.state.time.s}
            </p>
          </Form.Item>

          <Form.Item>
            {this.state.time.m === 0 && this.state.time.s === 0 ? (
              <Button onClick={this.requestOTP}>Resend OTP</Button>
            ) : (
              <Button type={"primary"} onClick={this.validateOTP}>
                Login
              </Button>
            )}
          </Form.Item>
        </div>
      </div>
    );
  }
}
